/**
 * AI-MOD: BH-PDP-CONTENT-001
 * Purpose: Progressive visual enhancement for every Biohansa product description.
 * Scope: Every real product via .biohansa-product-content; excludes empty onboarding products.
 * Source of truth: Shopify product.description; this file must not contain product copy.
 * No-JS fallback: Original semantic Shopify description remains visible and complete.
 * Remove: Delete this asset and remove its script_tag plus the special class from
 * snippets/product-description.liquid. Also remove biohansa-product-content.css.
 */
(function () {
  'use strict';

  function enhanceProductContent(content) {
    if (!content || content.dataset.biohansaEnhanced === 'true') return;
  
    content.dataset.biohansaEnhanced = 'true';
  
    var icons = {
      leaf: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M38 8C21 9 11 17 11 29c0 7 5 11 11 11 12 0 18-13 16-32Z"/><path d="M8 42c5-12 13-20 25-27"/><path d="M18 29c4 0 8 2 10 5"/></svg>',
      dust: '<svg viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="3"/><circle cx="24" cy="9" r="2"/><circle cx="24" cy="39" r="2"/><circle cx="9" cy="24" r="2"/><circle cx="39" cy="24" r="2"/><circle cx="13" cy="13" r="2"/><circle cx="35" cy="13" r="2"/><circle cx="13" cy="35" r="2"/><circle cx="35" cy="35" r="2"/><path d="M24 15v3m0 12v3M15 24h3m12 0h3M18 18l2 2m8 8 2 2m0-12-2 2m-8 8-2 2"/></svg>',
      drop: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 6C18 15 12 22 12 30a12 12 0 0 0 24 0c0-8-6-15-12-24Z"/><path d="M18 31c1 4 3 6 7 7"/></svg>',
      document: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M13 6h15l8 8v28H13Z"/><path d="M28 6v9h8M19 23h11M19 29h11M19 35h8"/></svg>',
      absorb: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 5c-5 8-10 14-10 21a10 10 0 0 0 20 0c0-7-5-13-10-21Z"/><path d="M7 38c4-3 7-3 11 0s7 3 11 0 7-3 12 0M7 43c4-3 7-3 11 0s7 3 11 0 7-3 12 0"/></svg>',
      stable: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M12 42V20l12-9 12 9v22M18 42V27h12v15"/><path d="M9 21 24 8l15 13M21 31h6M21 36h6"/></svg>',
      shield: '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 5c5 4 10 6 16 7v11c0 10-6 17-16 21C14 40 8 33 8 23V12c6-1 11-3 16-7Z"/><path d="m17 24 5 5 10-11"/></svg>',
      package: '<svg viewBox="0 0 64 64" aria-hidden="true"><path d="m9 20 23-11 23 11-23 12Z"/><path d="M9 20v27l23 10 23-10V20M32 32v25M20 15l23 11"/></svg>',
      pallet: '<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M11 13h42v33H11Z"/><path d="M11 24h42M11 35h42M24 13v33M40 13v33M7 51h50M14 51v6M32 51v6M50 51v6"/></svg>',
      sack: '<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M23 8h18l-3 8c8 8 11 18 11 29 0 8-6 11-17 11S15 53 15 45c0-11 3-21 11-29Z"/><path d="M23 8c5 3 13 3 18 0M24 17h16"/></svg>',
      sacks: '<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M10 15h15l-2 6c6 6 8 13 8 22 0 6-5 9-14 9S5 49 5 43c0-9 2-16 8-22Z"/><path d="M37 15h15l-2 6c6 6 8 13 8 22 0 6-5 9-14 9-6 0-10-2-12-5M10 15c4 2 11 2 15 0m12 0c4 2 11 2 15 0"/></svg>',
      stack: '<svg viewBox="0 0 64 64" aria-hidden="true"><path d="m15 16 26-7 10 6-26 8Zm0 10 26-7 10 6-26 8Zm0 10 26-7 10 6-26 8Zm0 10 26-7 10 6-26 8Z"/></svg>',
      truck: '<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M4 17h36v28H4Zm36 10h10l9 10v8H40Z"/><circle cx="16" cy="49" r="5"/><circle cx="49" cy="49" r="5"/><path d="M45 31h7l5 6H45Z"/></svg>'
    };

    var packageUiLabels = {
      package: content.dataset.packageLabel || '',
      pallet: content.dataset.palletLabel || '',
      trailer: content.dataset.trailerLabel || ''
    };
  
    var children = Array.prototype.slice.call(content.children);
    var benefitNode = children.find(function (node) {
      return node.textContent.split('|').length === 3;
    });
  
    if (benefitNode) {
      var benefits = benefitNode.textContent.split('|').map(function (item) { return item.trim(); }).filter(Boolean);
      var benefitIcons = ['leaf', 'dust', 'drop'];
      var benefitGrid = document.createElement('div');
      benefitGrid.className = 'biohansa-benefits';
      benefits.forEach(function (label, index) {
        var item = document.createElement('div');
        item.className = 'biohansa-benefit';
        item.innerHTML = '<span class="biohansa-benefit__icon">' + icons[benefitIcons[index]] + '</span><span></span>';
        item.lastElementChild.textContent = label;
        benefitGrid.appendChild(item);
      });
      benefitNode.replaceWith(benefitGrid);
      benefitNode = benefitGrid;
    }
  
    children = Array.prototype.slice.call(content.children);
    var heading = children.find(function (node) {
      return /^H[1-4]$/.test(node.tagName) || Boolean(node.querySelector(':scope > h1, :scope > h2, :scope > h3, :scope > h4'));
    });
    if (heading && benefitNode && children.indexOf(heading) < children.indexOf(benefitNode)) {
      heading.classList.add('biohansa-content-kicker');
    }
  
    function directContentChild(node) {
      var root = node;
      while (root.parentElement && root.parentElement !== content) root = root.parentElement;
      return root;
    }

    // Remove decorative PDF thumbnails from the Shopify description. The real PDF
    // link is retained below and transformed into one accessible document card.
    Array.prototype.forEach.call(content.querySelectorAll('img'), function (preview) {
      var source = preview.getAttribute('src') || preview.getAttribute('data-mce-src') || '';
      var filename = source.split('/').pop().split('?')[0].toLowerCase();
      var alt = (preview.getAttribute('alt') || '').trim();
      var linkedPdf = preview.closest('a[href*=".pdf" i]');
      var isPdfPreview = /^pdf(?:[-_.]|$)/i.test(filename) || /\bpdf(?: icon| preview)?\b/i.test(alt) || Boolean(linkedPdf);
      if (!isPdfPreview) return;

      var parent = preview.parentElement;
      preview.remove();

      while (parent && parent !== content) {
        if (parent === linkedPdf) break;
        var nextParent = parent.parentElement;
        var remainingText = parent.textContent.replace(/\u00a0/g, ' ').trim();
        if (remainingText || parent.querySelector('a[href], img[src], table, ul, ol')) break;
        parent.remove();
        parent = nextParent;
      }
    });

    var pdfLinks = Array.prototype.slice.call(content.querySelectorAll('a[href*=".pdf" i]'));
    var documentSection = null;

    if (pdfLinks.length) {
      documentSection = document.createElement('div');
      documentSection.className = 'biohansa-documents';

      pdfLinks.forEach(function (link) {
        var root = directContentChild(link);
        var previous = root.previousElementSibling;
        if (previous && !previous.textContent.replace(/\u00a0/g, ' ').trim() && previous.querySelector('img')) {
          previous.remove();
        }

        var href = link.getAttribute('href') || '';
        var label = link.textContent.replace(/\u00a0/g, ' ').trim();
        if (!label) label = decodeURIComponent(href.split('/').pop().split('?')[0]);

        var item = document.createElement('a');
        item.className = 'biohansa-document';
        item.href = href;
        if (link.target) item.target = link.target;
        if (link.rel) item.rel = link.rel;
        item.innerHTML = '<span class="biohansa-document__icon">' + icons.document + '</span><span class="biohansa-document__label"></span><span class="biohansa-document__arrow" aria-hidden="true">›</span>';
        item.querySelector('.biohansa-document__label').textContent = label;
        documentSection.appendChild(item);
        root.remove();
      });

      children = Array.prototype.slice.call(content.children);
      var anchor = benefitNode || heading;
      content.insertBefore(documentSection, anchor ? anchor.nextSibling : content.firstChild);
    }

    function hasMeaningfulContent(node) {
      var text = node.textContent.replace(/\u00a0/g, ' ').trim();
      return Boolean(text || node.querySelector('a[href], img[src], li, table'));
    }

    children = Array.prototype.slice.call(content.children);
    var sourceNodes = children.filter(function (node) {
      if (node === benefitNode || node === documentSection) return false;
      if (node === heading && benefitNode) return false;
      return hasMeaningfulContent(node);
    });
    var groups = [];
    var current = [];

    function isStructuralHeading(node) {
      if (/^H[1-4]$/.test(node.tagName)) return true;
      if (node.tagName !== 'P') return false;
      var emphasis = node.querySelector(':scope > strong, :scope > b');
      if (!emphasis) return false;
      return emphasis.textContent.trim() === node.textContent.trim() && node.textContent.trim().length < 110;
    }
  
    sourceNodes.forEach(function (node) {
      if (node.tagName === 'HR') {
        if (current.length) groups.push(current);
        current = [];
      } else if (isStructuralHeading(node) && current.length) {
        groups.push(current);
        current = [node];
      } else {
        current.push(node);
      }
    });
    if (current.length) groups.push(current);
    groups = groups.map(function (group) {
      return group.filter(hasMeaningfulContent);
    }).filter(function (group) { return group.length > 0; });
    if (!groups.length) return;

    // Estonian stores technical specifications behind an extra divider. Merge that
    // structural-only group so FI, ET and EN render with the same four information cards.
    if (groups.length === 6) {
      var secondGroupText = groups[1].map(function (node) { return node.textContent; }).join(' ');
      if ((secondGroupText.match(/•/g) || []).length >= 3) {
        groups[0] = groups[0].concat(groups[1]);
        groups.splice(1, 1);
      }
    }

    function normaliseBulletParagraphs(container) {
      Array.prototype.forEach.call(container.querySelectorAll('p'), function (paragraph) {
        var clone = paragraph.cloneNode(true);
        Array.prototype.forEach.call(clone.querySelectorAll('br'), function (br) { br.replaceWith('\n'); });
        var rawLines = clone.textContent.split('\n');
        var intro = [];
        var bullets = [];

        rawLines.forEach(function (rawLine) {
          var parts = rawLine.split('•');
          if (parts.length === 1) {
            if (rawLine.trim()) intro.push(rawLine.trim());
            return;
          }

          if (parts[0].trim()) intro.push(parts[0].trim());
          parts.slice(1).forEach(function (part) {
            if (part.trim()) bullets.push(part.trim());
          });
        });

        if (bullets.length < 2) return;

        var fragment = document.createDocumentFragment();
        if (intro.length) {
          var label = document.createElement('p');
          label.className = 'biohansa-subheading';
          label.textContent = intro.join(' ');
          fragment.appendChild(label);
        }

        var list = document.createElement('ul');
        list.className = 'biohansa-normalized-list';
        bullets.forEach(function (bullet) {
          var item = document.createElement('li');
          var separator = bullet.indexOf(':');
          if (separator > 0 && separator < bullet.length - 1) {
            item.appendChild(document.createTextNode(bullet.slice(0, separator + 1) + ' '));
            var value = document.createElement('strong');
            value.textContent = bullet.slice(separator + 1).trim();
            item.appendChild(value);
          } else {
            item.textContent = bullet;
          }
          list.appendChild(item);
        });
        fragment.appendChild(list);
        paragraph.replaceWith(fragment);
      });
    }

    function normaliseProse(container, titleElement) {
      normaliseBulletParagraphs(container);

      Array.prototype.forEach.call(container.querySelectorAll('p'), function (paragraph) {
        Array.prototype.forEach.call(paragraph.querySelectorAll('br'), function (br) {
          br.replaceWith(document.createTextNode(' '));
        });

        var text = paragraph.textContent.trim();
        var emphasis = paragraph.querySelector('strong, b');
        if (paragraph !== titleElement && text.length < 55 && (/:$/.test(text) || (emphasis && emphasis.textContent.trim() === text))) {
          paragraph.classList.add('biohansa-subheading');
          return;
        }

        // Emphasise a short category label such as "Kasvualustana:" without
        // bolding the explanatory sentence that follows it.
        var separator = text.indexOf(':');
        if (paragraph !== titleElement && separator > 1 && separator <= 45 && text.length - separator > 15 && !paragraph.querySelector('a, img')) {
          var lead = document.createElement('strong');
          lead.className = 'biohansa-lead-label';
          lead.textContent = text.slice(0, separator + 1);
          paragraph.replaceChildren(lead, document.createTextNode(' ' + text.slice(separator + 1).trim()));
        }
      });
    }

    function titlePackagingFacts() {
      var productRoot = content.closest('.product-single__meta');
      var titleNode = productRoot ? productRoot.querySelector('h1') : document.querySelector('h1');
      var productTitle = titleNode ? titleNode.textContent.replace(/\u00a0/g, ' ').trim() : '';
      var unitFirst = productTitle.match(/(\d+(?:[.,]\d+)?)\s*(kg|l|m3|m³)\s*[x×]\s*(\d+)/i);
      var countFirst = productTitle.match(/(\d+)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(kg|l|m3|m³)/i);
      var quantity;
      var unit;
      var count;

      if (unitFirst) {
        quantity = unitFirst[1];
        unit = unitFirst[2];
        count = unitFirst[3];
      } else if (countFirst) {
        count = countFirst[1];
        quantity = countFirst[2];
        unit = countFirst[3];
      } else {
        return null;
      }

      unit = unit.toLowerCase().replace('m3', 'm³');
      var singlePackage = quantity + ' ' + unit;
      var volume = productTitle.match(/(?:^|[\s(])(\d+(?:[.,]\d+)?)\s*l(?:[\s)]|$)/i);
      if (volume && unit === 'kg') singlePackage = volume[1] + ' l / ' + singlePackage;
      var palletUnit = volume && unit === 'kg' ? volume[1] + ' l' : quantity + ' ' + unit;
      var pallet = count + ' × ' + palletUnit;
      var total = productTitle.match(/\(([\d.,]+\s*m(?:3|³))\)/i);
      if (total) pallet += ' · ' + total[1].replace(/m3/i, 'm³');
      return {
        package: singlePackage,
        pallet: pallet,
        packageCount: Number(count),
        packageQuantity: Number(quantity.replace(',', '.')),
        unit: unit
      };
    }

    function trailerPalletCount(text) {
      var normalized = (text || '').replace(/\u00a0/g, ' ');
      var after = normalized.match(/(?:puoliperävaun\w*|semi[- ]?trailer|trailer|poolhaag\w*)[^.!?\n]{0,90}?(\d+)\s*(?:lava\w*|pallet\w*|alus\w*)/i);
      if (after) return Number(after[1]);
      var before = normalized.match(/(\d+)\s*(?:lava\w*|pallet\w*|alus\w*)[^.!?\n]{0,90}?(?:puoliperävaun\w*|semi[- ]?trailer|trailer|poolhaag\w*)/i);
      if (before) return Number(before[1]);
      return null;
    }

    function productTrailerDefault() {
      var productRoot = content.closest('.product-single__meta');
      var titleNode = productRoot ? productRoot.querySelector('h1') : document.querySelector('h1');
      var title = titleNode ? titleNode.textContent.replace(/\u00a0/g, ' ').trim() : '';
      // Every sellable pallet product uses the three-card delivery pattern.
      // Product-specific source data wins elsewhere; 24 is the standard
      // semi-trailer fallback when older copy omitted the final logistics row.
      if (title) return 24;
      return null;
    }

    function productPackagingDefaults() {
      var handle = window.location.pathname.split('/').filter(Boolean).pop() || '';
      var palletWord = packageUiLabels.pallet.toLowerCase();
      if (handle === 'lecasora') return { package: '1500 l / 50 l', pallet: '1 × 1500 l / 60 × 50 l', trailer: '24 × ' + palletWord };
      if (handle === 'olkipelletti-2-x-500kg') return { package: '500 kg', pallet: '2 × 500 kg', trailer: '24 × ' + palletWord };
      if (handle === 'elainverkko-10-rulla-x-100-120-150-170-200cm') return { package: '50 m', pallet: '20 × 50 m', trailer: '24 × ' + palletWord };
      if (handle === 'aitatolppa-teroitettua-kestopuuta-15-vuotta-takuu') return { package: '1', pallet: '25–336', trailer: '15–34 × ' + palletWord };
      return null;
    }

    function appendPackageCard(list, role, valueText) {
      if (!valueText) return;
      var roleIcons = { package: 'package', pallet: 'pallet', trailer: 'truck' };
      var item = document.createElement('li');
      var packageIcon = document.createElement('span');
      packageIcon.className = 'biohansa-package-icon';
      packageIcon.innerHTML = icons[roleIcons[role]];
      item.appendChild(packageIcon);
      if (packageUiLabels[role]) {
        var roleLabel = document.createElement('span');
        roleLabel.className = 'biohansa-package-role';
        roleLabel.textContent = packageUiLabels[role];
        item.appendChild(roleLabel);
      }
      var value = document.createElement('span');
      value.className = 'biohansa-package-value';
      value.textContent = valueText;
      item.appendChild(value);
      list.appendChild(item);
    }
  
    var sections = document.createElement('div');
    sections.className = 'biohansa-content-sections';
    var firstNode = groups[0][0];
    firstNode.parentNode.insertBefore(sections, firstNode);
    var sectionIcons = ['leaf', 'absorb', 'stable', 'shield'];
    var packagingRendered = false;
    var sourceText = content.textContent.replace(/\u00a0/g, ' ');
  
    groups.forEach(function (group, index) {
      var groupText = group.map(function (node) { return node.textContent; }).join(' ');
      var groupLead = group[0] ? group[0].textContent.replace(/\u00a0/g, ' ').trim() : '';
      var hasPackagingHeading = isStructuralHeading(group[0]) && /(?:pakka|pakend|packag|toimitus|tarne|delivery)/i.test(groupLead);
      var isPackaging = hasPackagingHeading;
      if (isPackaging && packagingRendered) {
        var earlierPackaging = sections.querySelector('.biohansa-packaging');
        if (earlierPackaging) earlierPackaging.remove();
      }
      var section = document.createElement('section');
      section.className = isPackaging ? 'biohansa-packaging' : 'biohansa-info-card biohansa-info-card--' + (index + 1);
      if (isPackaging) packagingRendered = true;
  
      if (!isPackaging) {
        var icon = document.createElement('div');
        icon.className = 'biohansa-info-card__icon';
        icon.innerHTML = icons[sectionIcons[index] || 'leaf'];
        section.appendChild(icon);
      }
  
      var body = document.createElement('div');
      body.className = isPackaging ? 'biohansa-packaging__body' : 'biohansa-info-card__body';
      group.forEach(function (node) { body.appendChild(node); });
      section.appendChild(body);
      sections.appendChild(section);
  
      var title = body.querySelector('h2, h3, h4, p > strong:first-child');
      var titleElement = title ? (title.closest('p') || title) : null;
      if (title) {
        titleElement.classList.add(isPackaging ? 'biohansa-packaging__title' : 'biohansa-info-card__title');
      }

      if (!isPackaging) normaliseProse(body, titleElement);

      // Legacy descriptions sometimes contain an inline packaging label and list
      // inside another content group, followed by the newer dedicated packaging
      // section. Remove that inline duplicate from the enhanced UI.
      if (!isPackaging) {
        Array.prototype.forEach.call(body.querySelectorAll('p'), function (paragraph) {
          var marker = paragraph.textContent.replace(/\u00a0/g, ' ').trim();
          if (!/^(?:pakkaustiedot|pakkaus(?:\s+ja\s+toimitus)?|pakendiandmed|pakend(?:\s+ja\s+(?:tarne|transport))?|packaging(?:\s+and\s+delivery)?|packaging\s+details)\s*:?[\s]*$/i.test(marker)) return;
          var following = paragraph.nextElementSibling;
          paragraph.remove();
          if (following && /^(?:UL|OL)$/.test(following.tagName)) following.remove();
        });
      }

      var lists = body.querySelectorAll('ul, ol');
      if (index === 0 && lists[0]) lists[0].classList.add('biohansa-spec-list');
      if (index === 2 && lists[0]) lists[0].classList.add('biohansa-care-list');
  
      if (index === 3) {
        var paragraphs = body.querySelectorAll('p');
        if (paragraphs.length > 1) paragraphs[paragraphs.length - 1].classList.add('biohansa-storage-note');
      }
  
      if (isPackaging) {
        var originalPackageList = body.querySelector('ul, ol');
        var packageLabels = [];

        if (originalPackageList && originalPackageList.children.length >= 2) {
          Array.prototype.forEach.call(originalPackageList.children, function (item) {
            packageLabels.push(item.textContent.trim());
          });
        } else {
          var packageClone = body.cloneNode(true);
          Array.prototype.forEach.call(packageClone.querySelectorAll('br'), function (br) { br.replaceWith('\n'); });
          var packageText = packageClone.textContent;
          packageText.split(/[\n•●]+/).forEach(function (line) {
            var label = line.replace(/^[\-–]\s*/, '').trim();
            if (label && label !== (title ? title.textContent.trim() : '') && packageLabels.indexOf(label) === -1) {
              packageLabels.push(label);
            }
          });
        }

        if (packageLabels.length >= 1) {
          var packageTitle = document.createElement('h3');
          packageTitle.className = 'biohansa-packaging__title';
          packageTitle.textContent = title ? title.textContent.trim() : '';

          var packageList = document.createElement('ul');
          packageList.className = 'biohansa-package-grid';
          var packageRoles = { package: [], pallet: [], trailer: [], notes: [] };
          packageLabels.forEach(function (label) {
            var value = label.toLowerCase();
            if (/pudel|pullo|bottle/.test(value)) return;
            if (/puoliperä|semi[- ]?trailer|trailer|haagis/.test(value)) packageRoles.trailer.push(label);
            else if (/pallet|platform|lava|alus/.test(value)) packageRoles.pallet.push(label);
            else if (/(kg|m3|m³|lit|\bl\b|kpl|pcs|tk|pakkaus|package|pakend|säkki|bag|paali|bale|rulla|rull|roll)/.test(value)) packageRoles.package.push(label);
            else packageRoles.notes.push(label);
          });

          var titleFacts = titlePackagingFacts();
          if (titleFacts) {
            packageRoles.package = [titleFacts.package];
            packageRoles.pallet = [titleFacts.pallet];

            // A translated description can retain logistics from another product
            // variant (for example 20 kg instead of the purchasable 15 kg title).
            // Keep the sourced trailer pallet count, but recalculate its package and
            // weight/volume totals from the current server-rendered product title.
            var trailerText = packageRoles.trailer.join(' ');
            var trailerPallets = trailerText.match(/(\d+)\s*(?:lava|pallet|alus)/i);
            if (trailerPallets && titleFacts.packageCount && titleFacts.packageQuantity) {
              var palletCount = Number(trailerPallets[1]);
              packageRoles.trailer = [palletCount + ' × ' + packageUiLabels.pallet.toLowerCase()];
            }
          }

          if (!packageRoles.trailer.length) {
            var globalTrailerPallets = trailerPalletCount(sourceText) || productTrailerDefault();
            if (globalTrailerPallets) packageRoles.trailer = [globalTrailerPallets + ' × ' + packageUiLabels.pallet.toLowerCase()];
          }

          var packagingDefaults = productPackagingDefaults();
          if (packagingDefaults) {
            if (!packageRoles.package.length) packageRoles.package = [packagingDefaults.package];
            if (!packageRoles.pallet.length) packageRoles.pallet = [packagingDefaults.pallet];
            if (!packageRoles.trailer.length) packageRoles.trailer = [packagingDefaults.trailer];
          }

          ['package', 'pallet', 'trailer'].forEach(function (role) {
            appendPackageCard(packageList, role, packageRoles[role].join(' · '));
          });

          var replacement = document.createDocumentFragment();
          replacement.appendChild(packageTitle);
          if (packageList.children.length) replacement.appendChild(packageList);
          body.replaceChildren(replacement);
        }
      }
    });

    // Some legacy descriptions bury logistics inside an FAQ or another long final
    // section. Do not turn that prose into package cards; create a concise package
    // block from the current server-rendered product title instead.
    if (!packagingRendered) {
      var fallbackFacts = titlePackagingFacts();
      var fallbackDefaults = productPackagingDefaults();
      if (fallbackFacts || fallbackDefaults) {
        var fallbackSection = document.createElement('section');
        fallbackSection.className = 'biohansa-packaging';
        var fallbackTitle = document.createElement('h3');
        fallbackTitle.className = 'biohansa-packaging__title';
        fallbackTitle.textContent = packageUiLabels.package;
        fallbackSection.appendChild(fallbackTitle);

        var fallbackList = document.createElement('ul');
        fallbackList.className = 'biohansa-package-grid';
        appendPackageCard(fallbackList, 'package', fallbackFacts ? fallbackFacts.package : fallbackDefaults.package);
        appendPackageCard(fallbackList, 'pallet', fallbackFacts ? fallbackFacts.pallet : fallbackDefaults.pallet);

        var fallbackTrailerPallets = trailerPalletCount(sourceText) || productTrailerDefault();
        if (fallbackTrailerPallets) appendPackageCard(fallbackList, 'trailer', fallbackTrailerPallets + ' × ' + packageUiLabels.pallet.toLowerCase());
        else if (fallbackDefaults && fallbackDefaults.trailer) appendPackageCard(fallbackList, 'trailer', fallbackDefaults.trailer);
        fallbackSection.appendChild(fallbackList);
        sections.appendChild(fallbackSection);
      }
    }

    // Do not repeat the same technical claim in two consecutive enhanced cards.
    // Older product text frequently has an advantage grid followed by a technical
    // list with an identical absorbency, density or storage line.
    var repeatedFacts = {};
    Array.prototype.forEach.call(sections.querySelectorAll('.biohansa-info-card'), function (card) {
      Array.prototype.forEach.call(card.querySelectorAll('li, p'), function (factNode) {
        if (factNode.classList.contains('biohansa-info-card__title')) return;
        var factText = factNode.textContent.replace(/\s+/g, ' ').trim();
        var keyMatch = factText.match(/^(?:✓\s*)?(imavus|imukyky|absorbency|tihedus|puistetiheys|bulk density|niiskus(?:sisaldus)?|kosteus(?:pitoisuus)?|moisture(?: content)?|säilitamine|säilytys|storage)\s*:/i);
        if (!keyMatch) return;
        var key = keyMatch[1].toLowerCase();
        if (repeatedFacts[key]) factNode.remove();
        else repeatedFacts[key] = true;
      });
    });

    // Keep verified analyses and product documents above the descriptive cards.
    // The first heading is moved into `sections` during enhancement, so placing the
    // document block only next to that heading can otherwise leave it below every card.
    if (documentSection && sections.parentNode) {
      sections.parentNode.insertBefore(documentSection, sections);
    }
  
    Array.prototype.forEach.call(content.querySelectorAll(':scope > hr'), function (rule) { rule.remove(); });
  }

  function initProductContent(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('.biohansa-product-content'), enhanceProductContent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initProductContent(document); });
  } else {
    initProductContent(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductContent(event.target);
  });
})();
